import React from 'react';

const ModalDefaultBody = ({ className = '', children }) => (
	<section className={`${className} modal-card-body`}>
		{children}
	</section>
);

export default ModalDefaultBody;
